export const buildErrorMessageModule = (message) => ({
    _type: 'StatusMessageModule',
    message: {
        title: {
            _type: 'TextualDisplay',
            textSpans: [
                {
                    '_type': 'TextSpan',
                    'text': message
                }
            ]
        },
        messageType: 'ERROR',
        displayIcon: true
    },
    meta: {
        name: 'STATUS_MESSAGE'
    }
});

export default {
    'en-US': buildErrorMessageModule('There seems to be a problem serving the request at this time'),
    'de-DE': buildErrorMessageModule('Leider ist bei dieser Anfrage momentan ein Problem aufgetreten')
};
